import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { unmountComponentAtNode } from "react-dom";
import { JSMAP } from "../../store/common/constants";
import "./map.scss";
import H from "@here/maps-api-for-javascript";
var Map = function (_a) {
    var address = _a.address, center = _a.center, markerLocation = _a.markerLocation, onMarkerChange = _a.onMarkerChange;
    var mapEl = React.useRef();
    var mapRef = React.useRef();
    var markerRef = React.useRef();
    var platformRef = React.useRef();
    var behaviorRef = React.useRef();
    React.useEffect(function () {
        var mapElement = mapEl.current;
        if (!mapRef.current) {
            platformRef.current = new H.service.Platform({
                apikey: JSMAP.APIKEY,
            });
            var defaultLayers = platformRef.current.createDefaultLayers();
            var map_1 = (mapRef.current = new H.Map(mapElement, defaultLayers.vector.normal.map, {
                zoom: 0,
                center: center,
                pixelRatio: window.devicePixelRatio || 1,
            }));
            H.ui.UI.createDefault(map_1, defaultLayers);
            behaviorRef.current = new H.mapevents.Behavior(new H.mapevents.MapEvents(map_1));
            markerRef.current = new H.map.Marker({ lng: 0, lat: 0 }, { data: "", zIndex: 2, volatility: true, visibility: false });
            var behavior_1 = behaviorRef.current;
            markerRef.current.draggable = true;
            map_1.addObject(markerRef.current);
            // disable the default drag of the map and calculate the offset between mouse and target's position when starting to drag a marker
            map_1.addEventListener("dragstart", function (ev) {
                var target = ev.target;
                var pointer = ev.currentPointer;
                if (target instanceof H.map.Marker) {
                    var targetGeometry = target.getGeometry();
                    var targetPosition = map_1.geoToScreen(targetGeometry);
                    target["offset"] = new H.math.Point(pointer.viewportX - targetPosition.x, pointer.viewportY - targetPosition.y);
                    behavior_1.disable();
                }
            }, false);
            // re-enable the default drag of the underlying map when dragging has completed
            map_1.addEventListener("dragend", function (_a) {
                var target = _a.target, currentPointer = _a.currentPointer;
                if (target instanceof H.map.Marker) {
                    var _b = map_1.screenToGeo(currentPointer.viewportX - target["offset"].x, currentPointer.viewportY - target["offset"].y), lng = _b.lng, lat = _b.lat;
                    behavior_1.enable();
                    onMarkerChange({ position: { lng: lng, lat: lat } });
                }
            }, false);
            // Listen to the drag event and move the position of the marker as necessary
            map_1.addEventListener("drag", function (_a) {
                var target = _a.target, currentPointer = _a.currentPointer;
                if (target instanceof H.map.Marker) {
                    var _b = map_1.screenToGeo(currentPointer.viewportX - target["offset"].x, currentPointer.viewportY - target["offset"].y), lng = _b.lng, lat = _b.lat;
                    target.setGeometry({ lng: lng, lat: lat });
                }
            }, false);
        }
        return function () {
            unmountComponentAtNode(mapElement);
        };
    }, [mapRef, center, onMarkerChange]);
    React.useEffect(function () {
        var map = mapRef.current;
        var marker = markerRef.current;
        var lng = markerLocation.lng, lat = markerLocation.lat;
        if (map && marker && lng && lat) {
            marker.setGeometry({ lng: lng, lat: lat });
            // if marker outside viewport recenter map
            map.getObjectsWithin(map.getViewModel().getLookAtData().bounds, function (res) {
                if (res.indexOf(marker) === -1) {
                    map.setCenter({ lng: lng, lat: lat });
                }
            });
        }
    }, [markerLocation]);
    React.useEffect(function () {
        var map = mapRef.current;
        var platform = platformRef.current;
        var marker = markerRef.current;
        if (map && platform && marker && address !== "") {
            platform.getSearchService().geocode({
                q: address,
            }, function (result) {
                var items = result.items;
                var topResult = items[0];
                if (topResult) {
                    onMarkerChange(topResult);
                    marker.setVisibility(true);
                    marker.setGeometry(topResult.position);
                    map.setCenter(topResult.position);
                    map.setZoom(16);
                }
            }, console.warn);
        }
    }, [address, onMarkerChange]);
    return (_jsx("div", { className: "Map", ref: mapEl }));
};
export default Map;
